export default __webpack_public_path__ + "static/LinkedIn-3dc17c16d7947b4c583b67c9014e5550ac3f765b2f379f21a702664704c9b9c3.png";